export default __webpack_public_path__ + "static/media/arrow-down.f3ddc352.svg";